import { Box } from '@mui/material'
import Logo from 'assets/logo.png'

export const OrderwireHeight = 90

function OrderwireLogo() {
    return (
        <Box maxHeight={OrderwireHeight}>
            <img src={Logo} alt="Logo" width={320} />
        </Box>
    )
}

export default OrderwireLogo
